import React from "react";
import { MessageCircle } from "lucide-react";
import { brand } from "../content";

export const WhatsAppFloat = () => {
  const url = `https://wa.me/${brand.phoneRaw}?text=${encodeURIComponent(
    `Hi ${brand.short}, I'd like to discuss an interior project.`
  )}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-8 right-8 z-50 inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full text-white animate-wa-pulse hover:scale-105 transition-transform duration-300"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle size={26} strokeWidth={1.8} className="md:hidden" />
      <MessageCircle size={30} strokeWidth={1.8} className="hidden md:block" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
};
